module.exports = __webpack_public_path__ + "static/media/food.15c612e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/food.png
// module id = 1583
// module chunks = 0